module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.2bc6cb9d9e868430f6c2.js");
};